<script lang="ts">
    import { fade, scale } from 'svelte/transition';
    import type { Snippet } from 'svelte';

    interface Props {
        open: boolean;
        title?: string;
        maxWidth?: string;
        panelClass?: string;
        children: Snippet;
    }

    let {
        open = $bindable(false),
        title = '',
        maxWidth = 'max-w-md',
        panelClass = '',
        children,
    }: Props = $props();

    function handleBackdrop(e: MouseEvent) {
        if (e.target === e.currentTarget) {
            open = false;
        }
    }

    function handleKeydown(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            open = false;
        }
    }
</script>

<svelte:window onkeydown={open ? handleKeydown : undefined} />

{#if open}
    <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        onclick={handleBackdrop}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        transition:fade={{ duration: 150 }}
    >
        <div class="bg-gray-900 rounded-lg shadow-xl w-full {maxWidth} mx-4 p-6 {panelClass}" transition:scale={{ duration: 200, start: 0.95 }}>
            {#if title}
                <h3 id="modal-title" class="text-lg font-semibold text-gray-100 mb-4">{title}</h3>
            {/if}
            {@render children()}
        </div>
    </div>
{/if}
